import { createReducer } from '@ngrx/store';
import { Action, on } from '@ngrx/store';
import { MultiSignerSignState, TransferStatus } from '@shared/models';
import {
  ClearMXMState,
  MXMApprovalCompleted,
  MXMApprovalFailed,
  MXMApprovalInProgress,
  MXMFinalCompleted,
  UpdateIsFinalSigner,
  UpdateMXMSignState,
  UpdateMXMTransferId,
  UpdateMXMTransferStatus,
} from '@store/actions/mxm/mxm.actions';

export enum MXMApprovalStatus {
  EMPTY = 'EMPTY',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface MXMState {
  approvalStatus: MXMApprovalStatus;
  transferId: string;
  signState: MultiSignerSignState;
  isFinalSigner: boolean;
  status: TransferStatus;
}

export const initialState: MXMState = {
  approvalStatus: null,
  transferId: null,
  signState: null,
  isFinalSigner: false,
  status: null,
};

export const MXMReducer = createReducer(
  initialState,
  on(MXMApprovalFailed, (state) => {
    return {
      ...state,
      approvalStatus: MXMApprovalStatus.ERROR,
    };
  }),
  on(MXMApprovalCompleted, (state) => {
    return {
      ...state,
      approvalStatus: MXMApprovalStatus.SUCCESS,
    };
  }),
  on(MXMFinalCompleted, (state) => {
    return {
      ...state,
      approvalStatus: MXMApprovalStatus.SUCCESS,
    };
  }),
  on(MXMApprovalInProgress, (state) => {
    return {
      ...state,
      approvalStatus: MXMApprovalStatus.PENDING,
    };
  }),
  on(UpdateMXMTransferId, (state, { payload }) => ({
    ...state,
    transferId: payload,
  })),
  on(UpdateIsFinalSigner, (state, { payload }) => ({
    ...state,
    isFinalSigner: payload,
  })),
  on(UpdateMXMSignState, (state, { payload }) => ({
    ...state,
    signState: payload,
  })),
  on(UpdateMXMTransferStatus, (state, { payload }) => ({
    ...state,
    status: payload,
  })),
  on(ClearMXMState, () => ({
    ...initialState,
  })),
);

export function reducer(state: MXMState | undefined, action: Action) {
  return MXMReducer(state, action);
}

export const getMXMApprovalStatus = (state: MXMState) => (state ? state.approvalStatus : null);
export const getMXMTransferId = (state: MXMState) => (state ? state.transferId : null);
export const getMXMSignState = (state: MXMState) => (state ? state.signState : null);
export const getIsFinalSigner = (state: MXMState) => (state ? state.isFinalSigner : false);
export const getMXMTransferStatus = (state: MXMState) => (state ? state.status : null);
